export enum ApiResult {
  Error,
  Ok,
}

export interface ApiOkResult {
  ok: true;
}
